var $3f928e96a4e35d18$exports = {};
const $3f928e96a4e35d18$var$hardware = [
    "mouse",
    "keyboard",
    "screen"
];
console.log($3f928e96a4e35d18$var$hardware);
const $3f928e96a4e35d18$var$tekst = "co ten frontend";
const $3f928e96a4e35d18$var$textLegth = $3f928e96a4e35d18$var$tekst.length;
const $3f928e96a4e35d18$var$myObject = {
    name: "Paweł",
    age: "37"
};
$3f928e96a4e35d18$var$hardware.push($3f928e96a4e35d18$var$myObject);
console.log($3f928e96a4e35d18$var$hardware.indexOf($3f928e96a4e35d18$var$myObject));
console.log($3f928e96a4e35d18$var$hardware);
$3f928e96a4e35d18$var$hardware.unshift("test");
console.log($3f928e96a4e35d18$var$hardware);
$3f928e96a4e35d18$var$hardware.shift();
console.log($3f928e96a4e35d18$var$hardware);
$3f928e96a4e35d18$var$hardware.pop();
console.log($3f928e96a4e35d18$var$hardware[2]);
console.log($3f928e96a4e35d18$var$hardware.length);
console.log($3f928e96a4e35d18$var$tekst[3]);
console.log($3f928e96a4e35d18$var$tekst[$3f928e96a4e35d18$var$textLegth - 1]);
console.log($3f928e96a4e35d18$var$hardware);
console.log($3f928e96a4e35d18$var$tekst.indexOf("fr"));
if ($3f928e96a4e35d18$var$tekst.indexOf("Paweł") >= 0) console.log("Paweł znaleziony");
else console.log("Paweł nie znaleziony");
$3f928e96a4e35d18$var$hardware.splice(0, 1);
console.log($3f928e96a4e35d18$var$hardware);
const $3f928e96a4e35d18$var$newHardware = $3f928e96a4e35d18$var$hardware.slice(0, 1);
console.log($3f928e96a4e35d18$var$newHardware);
console.log($3f928e96a4e35d18$var$tekst.slice(3, 8));


//# sourceMappingURL=index.f2a1a0ab.js.map
